import { ICompany } from '@types';

function isAccountPaused(company: ICompany) {
  return company?.deactivated;
}

export default isAccountPaused;
